"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "accountsDailyFlow",
    path: "/accounts-daily-flow",
    component: "AccountsDailyFlow"
});
let AccountsDailyFlow = class AccountsDailyFlow extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_parameters = new core_1.ComponentValueCache(this, "parameters", "AccountsDailyFlowViewFilters");
    }
    getItems(...args) {
        const parameters = this.parameters;
        return this.$fn.fetch('browse_accounts_daily_flow', {
            parameters: {
                ...parameters,
                account: parameters.account.id
            }
        });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    accounts;
    async $$load_accounts() {
        return this.$fn.fetch('list_account')
            .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']));
    }
    parameters;
    async $$load_parameters() {
        return {
            date_from: null,
            date_to: null,
            account: this.accounts ? this.accounts[0] : null,
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'accounts', 'parameters', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                accounts: null,
                parameters: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "date",
                        name: this.$fn.pgettext("AccountsDailyFlowView", "Date"),
                    },
                    {
                        field: "open",
                        name: this.$fn.pgettext("AccountsDailyFlowView", "Opening balance"),
                        type: "number",
                        noFooterTotals: true,
                        formatter: "number",
                    },
                    {
                        field: "pay_in",
                        name: this.$fn.pgettext("AccountsDailyFlowView", "Pay in"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "pay_out",
                        name: this.$fn.pgettext("AccountsDailyFlowView", "Pay out"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "close",
                        name: this.$fn.pgettext("AccountsDailyFlowView", "Closing balance"),
                        type: "number",
                        noFooterTotals: true,
                        formatter: "number",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("AccountsDailyFlowView", "Daily Flow"),
                icon: this.$config.accountsDailyFlow.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7814_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_7816_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_7818_getActionArgs($event) {
        return {
            name: "Account",
            props: {
                oid: $event.data.data.account_id,
            },
        };
    }
    async evh_2248226175642056_command_7817_getWhen($event) {
        return $event.data.column.id === 'account_name';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_setData_7820_getActionArgs($event) {
        return {
            path: "parameters.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_8320016629450276_setData_7822_getActionArgs($event) {
        return {
            path: "parameters.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_8320016629450276_changed(event, scope) {
        return await this.actions.evh_8320016629450276_changed.executeFromDOM(this, event, scope);
    }
    async act_6705964765214521_reloadSlickgrid_7824_getActionArgs($event) {
        return {
            grid: "accountsDailyFlow",
        };
    }
    async evh_6705964765214521_click(event, scope) {
        return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7814 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7814_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7813 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7814,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7813],
        });
        const act_2248226175642056_setData_7816 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7816_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_7815 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7816,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_7815],
        });
        const act_2248226175642056_showModal_7818 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_7818_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_7817 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_7818,
            event: "command",
            when: this.evh_2248226175642056_command_7817_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_7817],
        });
        const act_8320016629450276_setData_7820 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8320016629450276_setData_7820_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_changed_7819 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_setData_7820,
            event: "changed",
            displayName: "setData",
        });
        const act_8320016629450276_setData_7822 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8320016629450276_setData_7822_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_changed_7821 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_setData_7822,
            event: "changed",
            displayName: "setData",
        });
        const evh_8320016629450276_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_changed_7819, evh_8320016629450276_changed_7821],
        });
        const act_6705964765214521_reloadSlickgrid_7824 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6705964765214521_reloadSlickgrid_7824_getActionArgs,
            displayName: "load",
            events: [],
        });
        const evh_6705964765214521_click_7823 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_reloadSlickgrid_7824,
            event: "click",
            displayName: "load",
        });
        const evh_6705964765214521_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_click_7823],
        });
        return {
            act_7315092382398562_closeModal_7814,
            evh_7315092382398562_close_7813,
            evh_7315092382398562_close,
            act_2248226175642056_setData_7816,
            evh_2248226175642056_selectedRowsChanged_7815,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_7818,
            evh_2248226175642056_command_7817,
            evh_2248226175642056_command,
            act_8320016629450276_setData_7820,
            evh_8320016629450276_changed_7819,
            act_8320016629450276_setData_7822,
            evh_8320016629450276_changed_7821,
            evh_8320016629450276_changed,
            act_6705964765214521_reloadSlickgrid_7824,
            evh_6705964765214521_click_7823,
            evh_6705964765214521_click,
            load: act_6705964765214521_reloadSlickgrid_7824,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], AccountsDailyFlow.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AccountsDailyFlow.prototype, "onSize", null);
AccountsDailyFlow = __decorate([
    (0, vue_property_decorator_1.Component)()
], AccountsDailyFlow);
exports.default = AccountsDailyFlow;
vue_property_decorator_1.Vue.component("AccountsDailyFlow", AccountsDailyFlow);
